module.exports = __webpack_public_path__ + "static/media/wallet.5d06ef91.svg";